import React, {useEffect,useState} from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
// import storedata from './MyData.json';
// import Categorydata from './MyCategory.json';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import UserService from '../services/UserService';
import { hasDeals } from '../services/categories';
import { useNavigate } from 'react-router-dom';

import './Headercss.css';

function Header() {
  

    const [searchstring,setSearchString]=useState("")
    const[categoryData,SetCategory]=useState([]);
    const[storeData,SetStore]=useState([]);
    const navigate=useNavigate();
    useEffect(
        ()=>{
       UserService.getStore().then((res)=>SetStore(res.data)).catch((err)=>console.error("Failed to load stores", err))
       UserService.getCategory().then((res)=>SetCategory(res.data)).catch((err)=>console.error("Failed to load categories", err))
      },[]);
       const goSearch=(e)=>{
            e.preventDefault();
            if (searchstring.trim() === "") return;
            navigate("/search/"+searchstring.trim())
       }
       const handleChange=(e)=>{
        setSearchString(e.target.value)
       }

        return (
          <Navbar expand="lg" className="tertiary" id='navbardropdown' >
            <Container>
              <Navbar.Brand href="/" className="brand">Dino<span>Dealz</span></Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav"  />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link href="/">Home</Nav.Link>
                  <Nav.Link href="/category/Freebies">Freebies</Nav.Link>
                  <NavDropdown title="Stores">
                    {storeData.map((data) =>
                      <NavDropdown.Item href={"/store/" + data.store} key={data.store_id ?? data.store}>{data.store}</NavDropdown.Item>
                    )}
                  </NavDropdown>
                  <NavDropdown title="Category">
                    {/* old: {categoryData.map((data) => */}
                    {/* new: only show categories that have deals */}
                    {categoryData.filter(hasDeals).map((data) =>
                      <NavDropdown.Item href={"/category/" + data.category} key={data.category}>{data.category}</NavDropdown.Item>
                      )}
                  </NavDropdown>
                  <Nav.Link href="/blog">Blog</Nav.Link>
                </Nav>
                <Form className="header-search" onSubmit={goSearch}>
                  <Form.Control
                    type="search"
                    placeholder="Search deals..."
                    aria-label="Search" onChange={handleChange}/>
                  <Button type="submit">Search</Button>
                </Form>
              </Navbar.Collapse>
            </Container>
          </Navbar>

     
            
        );


    }


export default Header;